import { UPDATE_ORDER_PLACED_REQUEST, FETCH_ORDER_PLACED_REQUEST, FETCH_ORDER_PLACED_FAILURE } from "@/redux/actions";
const initialState = {
    data: {},
    loading: false,
    error: null,
};
const getOrderPlacedReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_ORDER_PLACED_REQUEST: {
            state.data[action.payload.orderId] = action.payload.data;
            return Object.assign(Object.assign({}, state), { loading: false, error: null });
        }
        case FETCH_ORDER_PLACED_REQUEST:
            return Object.assign({}, state);
        case FETCH_ORDER_PLACED_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        default:
            return state;
    }
};
export default getOrderPlacedReducer;
